import React from 'react';
import { Button, ButtonFill, ButtonWidth, ComponentColor, ComponentSize, Container, Dialog, DialogWidth, FdsIcon, Icon, Orientation, Typography, TypographyVariant } from '@tcc/fds';
import { getMessage } from '@tcc/i18n';
import type { BaseFieldRegionReportModalParams } from './types/modals';

export interface RegionReportModalProps extends BaseFieldRegionReportModalParams {
  modalViewKey: string;
  children?: React.ReactNode;
  onStepBack?: () => void;
}

const getTitle = (onStepBack?: () => void) => (
  <Container
    width='100%'
    orientation={Orientation.Horizontal}>
    {onStepBack && (
      <Button
        fill={ButtonFill.Ghost}
        iconOnly
        width={ButtonWidth.FitContent}
        onClick={onStepBack}
        color={ComponentColor.Primary}
        testId="frr-go-back-button"
        aria-label={getMessage('confirmationModal.goBack')}
        size={ComponentSize.Sm}>
        <Icon icon={FdsIcon.ArrowBack} />
      </Button>
    )}

    <Typography tag="h2" variant={TypographyVariant.Subheading}>
      {getMessage('regions.report.modal.title')}
    </Typography>
  </Container>
);

export const RegionReportModal = ({
  onOpenChange,
  dialogTestId,
  modalViewKey,
  children,
  onStepBack,
}: RegionReportModalProps) => (
    <Dialog
      testId={dialogTestId}
      key={modalViewKey}
      onOpenChange={onOpenChange}
      defaultOpen
      open
      isModal
      width={DialogWidth.Wide}
      closeOnOutsideClick={false}
      headerProps={{
        showCloseButton: true,
        title: getTitle(onStepBack),
      }}
    >
      {children}
    </Dialog>
  );